// SEO Data centralized for all pages and languages
import generated from './seoData.generated.json';
import base from './seoData.base.json';

// Merge AI-generated translations (es, de, it, pt, ru, zh, ar, hi, ja) with base (en, fr).
// base wins for en/fr.
export const seoData = { ...generated, ...base };

// Helper function to get SEO data for a specific page and locale
export const getSeoData = (page, locale = 'en') => {
  return seoData[locale]?.[page] || seoData.en[page];
};
